module.exports = __webpack_public_path__ + "static/img/IMG_20160915_212809.69649242.jpg";